// extracted by mini-css-extract-plugin
export default {"heroWrapper":"lkWeLdhRKV5dZHneBtf9"};